import React from 'react';
import PropTypes from 'prop-types';

import Input from 'form/components/input/input';
import DocumentMetadataFieldsInputGroup from '../form/document_metadata_fields_input_group.jsx';

import DocumentStoreItem from '../../models/document_store_item';
import DocumentSubmitDataContainers from '../../constants/document_submit_data_containers';
import { DocumentActions } from '../../reflux/document_store';

export default class CreateDocumentModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		title: 'template.titles.create',
		className: 'create-document-modal',
		store: new DocumentStoreItem()
	};

	constructor(props) {
		super(props);
		this.createDocument = this.createDocument.bind(this);
		this.selectDefaultFileType = this.selectDefaultFileType.bind(this);
		this.handleCloseDocumentModal = this.handleCloseDocumentModal.bind(this);
		this.fileTypeSelected = this.fileTypeSelected.bind(this);
	}

	get template() {
		return this.props.store.template;
	}

	get waitingForAction() {
		return this.props.store.waitingForAction;
	}

	fileTypeSelected() {
		const { submitData } = this.props.store;
		const createSubmitData = submitData[DocumentSubmitDataContainers.CREATE];

		if(createSubmitData !== undefined){
			let typeFile = createSubmitData.defaultType;

			let allowedFileTypes = this.props.store.template.allowedFileTypes;

			let validateType = allowedFileTypes.length > 0 ? allowedFileTypes.includes(typeFile) : null;

			if(validateType === false){
				DocumentActions.displayFlashMessage(this.props.id, {type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypes`).replace('@@type@@', allowedFileTypes)});
			} else {
				DocumentActions.dismissFlashMessage(this.props.id);
			}
		}


		return createSubmitData ? createSubmitData.defaultType : [];
	}

	get fileTypeIsSelected() {
		return this.props.store.documentFileSelected;
	}

	handleCloseDocumentModal() {
		const { fileTypesSelect } = this.refs;
		fileTypesSelect.setState({value: null});
	}

	createDocument() {
		DocumentActions.createDocument(this.props.id);
	}

	setSubmitDataField(fieldKey, event, fieldValue) {
		const dataFieldValue = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;
		const dataFieldKey = `${DocumentSubmitDataContainers.CREATE}.${fieldKey}`;

		DocumentActions.setSubmitDataField(this.props.id, dataFieldKey, dataFieldValue);
		return false;
	}

	selectDefaultFileType(event, selectedValue) {
		this.setSubmitDataField("defaultType", event, selectedValue);
		DocumentActions.setDocumentFileSelected(this.props.id, selectedValue);
	}

	renderDefaultModelFileNameInput() {
		const defaultModel = this.template.defaultModel;

		return (
			<Input
				ref="fileNameInput"
				component="text"
				label={Realize.i18n.t('template.attributes.fileName')}
				className="col l12 m12 s12"
				value={defaultModel}
				onChange={this.setSubmitDataField.bind(this, "fileName")}
				readOnly={true}
			/>
		);
	}

	positionInputAutoCompletCreateDocument(){
		if($('#documentModal').is(':visible') === true){
			let heightModal = $('#documentModal .modal-content-container').height();
			let heightAutocomplete = $('#documentModal .modal-create-document .input-autocomplete #boxSearch__undefined').height() || $("#boxSearch__Tipo_do_Arquivo").height();
			if(heightAutocomplete > heightModal){
				$('#documentModal .modal-content-container').css('height', heightModal + heightAutocomplete);
			}
		}
	}

	renderFileTypesAutocomplete() {
		const fileTypes = this.template.fileTypes;

		return (
			<Input
				ref="fileTypesSelect"
				component="autocomplete"
				label={Realize.i18n.t('template.attributes.fileType')}
				className="col l12 m12 s12"
				options={fileTypes}
				required={true}
				clientSideSearch={true}
				onChange={this.selectDefaultFileType}
				value={this.fileTypeSelected}
				onClick={(e) => { this.positionInputAutoCompletCreateDocument(); }}
			/>
		);
	}

	render() {
		return (
			<div className="modal-create-document">
				<div className="row">
					{!!this.template.defaultModel ? this.renderDefaultModelFileNameInput() : this.renderFileTypesAutocomplete()}
				</div>
				<div className="row">
					<DocumentMetadataFieldsInputGroup {...this.props} containerId={DocumentSubmitDataContainers.CREATE} />
				</div>
			</div>
		);
	}
}
